import type { Action } from 'redux';
import type { IBulkCollection } from '../../../../../../shared/types/bulkCollection';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { FetchAllLinkCollectionsResponseActionPayload } from '../types';

const FetchAllLinkCollections = new ReduxAsyncAction<
  'FETCH_ALL_LINK_COLLECTIONS',
  void,
  FetchAllLinkCollectionsResponseActionPayload
>('FETCH_ALL_LINK_COLLECTIONS');

FetchAllLinkCollections.registerRequest(async () => {
  try {
    const response = await dash_api.get<IBulkCollection[]>('/v1/linkhub/collections');
    return {
      allLinkCollections: response?.data,
    };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch all link collections.', 'error');

    throw error;
  }
});

export const FETCH_ALL_LINK_COLLECTIONS = FetchAllLinkCollections.actionNamespaceConstants;

export const fetchAllLinkCollections = FetchAllLinkCollections.request;

export type FetchAllLinkCollectionsResponseAction = Action<typeof FETCH_ALL_LINK_COLLECTIONS.response> & {
  data: FetchAllLinkCollectionsResponseActionPayload;
};
